import {URL} from '../index';
import axios from '../../http';

export function getAftersaleProcessMap(params={}) {
    return axios.get(`${URL}/aftersale/process/map`,{params});
}